<style lang="scss" scoped>
</style>
<template>
  <div class="l-role-box">
    <div class="l-container-title">
      <i class="el-icon-s-custom" /><b>角色列表</b>
      <l-auth-text-button auth="role_add_btn" type="primary" style="float:right;font-size:14px" @click="showAdd">
        <i class="el-icon-plus" style="font-size:14px;" />添加
      </l-auth-text-button>
    </div>

    <div class="l-role-list-main">
      <ul class="l-role-list">
        <li :class="{'l-role-active':select_id==item.id||show_action_id==item.id}" v-for="item in list" :key="item.id" @click="checkRole(item.id)" @mouseover="show_action_id=item.id" @mouseleave="show_action_id=''">
          <div>
            <span v-text="item.name"></span>
            <span style="float:right" v-if="select_id==item.id||show_action_id==item.id">
              <l-auth-text-button auth="role_edit_btn" type="primary" @click.stop="showEdit(item.id)">
                <i class="el-icon-edit"></i>
              </l-auth-text-button>
              <l-auth-text-button auth="role_del_btn" type="danger" @click.stop="del(item.id)" style="margin-left:10px">
                <i class="el-icon-delete"></i>
              </l-auth-text-button>
            </span>

          </div>

        </li>
      </ul>
    </div>

    <!--添加角色弹窗-->
    <l-dialog :visible.sync="show_add" title="创建角色" width="500px">
      <l-role-edit @on-success="onAddSuccess" :visible.sync="show_add" />
    </l-dialog>

    <!--编辑角色弹窗-->
    <l-dialog :visible.sync="show_edit" title="编辑角色" width="500px">
      <l-role-edit @on-success="onEditSuccess" :visible.sync="show_edit" :id="edit_id" />
    </l-dialog>

  </div>
</template>

<script>
  import RoleEdit from './Edit'
  export default {
    name: 'l-role-list',

    components: {
      [RoleEdit.name]: RoleEdit
    },

    props: {
      id: {
        type: [String, Number],
        default: ''
      }
    },

    data() {
      return {
        spinning: false,
        list: [],
        select_id: '',
        show_action_id: '',

        show_add: false,

        show_edit: false,
        edit_id: '',

        del_id: ''
      }
    },

    mounted() {
      this.getList();
    },

    methods: {
      getList() {
        this.spinning = false;
        this.$_invoke('role_getList', {
          of_type:this.$props.id
        }).then((ret) => {
          this.list = ret.data;
          //如果未选中角色，则进行选中
          if (!this.select_id) {
            if (this.list.length > 0) {
              this.checkRole(this.list[0].id);
            }
          }
        }).finally(() => {
          this.spinning = false
        });
      },

      //选中某个角色
      checkRole(id) {
        //点击角色前的前置事件
        this.$emit('on-before-check');
        this.$nextTick(() => {
          this.select_id = id;
          this.$emit('on-after-check', id);
        })
      },

      //添加角色
      showAdd() {
        this.show_add = true;
      },

      //添加成功处理方法
      onAddSuccess() {
        this.show_add = false;
        this.getList();
      },

      //修改角色
      showEdit(id) {
        this.edit_id = id;
        this.$nextTick(() => {
          this.show_edit = true;
        })
      },

      //修改成功回调
      onEditSuccess() {
        this.show_edit = false;
        this.getList();
      },

      //删除
      del(id) {
        this.$confirm('确定删除该条记录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.$_invoke(`role_delete`, { id }).then(() => {
            this.$_msg.success('删除成功');
            this.getList();
          });
        }).catch(() => {
        });
      },

      //显示/隐藏操作栏
      showAction(id) {
        this.show_action_id = id;
      }
    }
  }
</script>